// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"r4-z","colorTextValue":"s4-z","swatches":"t4-z","collapseLink":"u4-z","isCollapsed":"v4-z","dropdown":"w4-z","disabled":"x4-z"};